<template>
  <div>
    <a-skeleton active v-if="loading" />

    <div v-else>
      <div>
        <!-- add  activityDRAWER -->
        <a-drawer
          :title="$t('inscription.nouvInscri')"
          :width="720"
          :visible="inscriptinActDrawer"
          :body-style="{ paddingBottom: '80px' }"
          @close="onClose"
        >
          <activity-ins-form
            :studentId="studentId"
            @updateActivityInscription="updateActivities"
          ></activity-ins-form>
        </a-drawer>

        <!-- Edit Activity Modal -->
        <edit-activity-modal
          :visible="editModalVisible"
          :activity-data="selectedActivity"
          :student-id="studentId"
          @close="closeEditModal"
          @updatePayment="handleUpdatePayment"
        />

        <a-button
          type="primary"
          icon="plus"
          class="mb-3"
          @click="startInsDrawer"
        >
          {{ $t("inscription.nouvInscri") }}
        </a-button>
      </div>
      <div>
        <a-collapse
          expand-icon-position="left"
          default-active-key="0"
          @change="changeActivekey"
        >
          <a-collapse-panel
            :header="item.name"
            v-for="(item, index) in data"
            :key="index"
          >
            <div slot="extra" class="d-flex" style="gap: 8px">
              <a-button
                type="primary"
                size="small"
                :loading="loadingSave"
                :disabled="item.once"
                @click="editActInsc(item)"
              >
                <a-icon type="edit" />{{ $t("all.edit") }}
              </a-button>
              <a-popconfirm
                :title="$t('paiement.annulerInscri')"
                @confirm="() => cancelActInsc(item)"
              >
                <a-button type="danger" size="small">
                  <a-icon type="delete" href="javascript:;" />{{
                    $t("action.annuler")
                  }}
                </a-button>
              </a-popconfirm>
            </div>
            <a-tag color="cyan" class="mb-2">
              {{
                item.mode == "M" ? $t("inscription.monthlyPayment") : $t("inscription.installmentPayment")
              }}
            </a-tag>

            <!-- View toggle for daily activities -->
            <div
              v-if="item.daily"
              class="mb-2 d-flex"
              style="gap: 8px; align-items: center"
            >
              <a-button-group>
                <a-button
                  :type="isCalendarView(item) ? 'primary' : 'default'"
                  size="small"
                  @click="setViewMode(item, 'calendar')"
                >
                  {{ $t("calender.calendar") }}
                </a-button>
                <a-button
                  :type="!isCalendarView(item) ? 'primary' : 'default'"
                  size="small"
                  @click="setViewMode(item, 'table')"
                >
                  {{ $t("all.table") }}
                </a-button>
              </a-button-group>
            </div>

            <!-- Calendar view for daily activities -->
            <div
              v-if="item.daily && isCalendarView(item)"
              class="daily-activity-view"
            >
              <DailyCalendar
                :show-selected-dates="false"
                :selected-dates="getDailyUnpaidDates(item)"
                :activity-start="item.start ? moment(item.start) : null"
                :activity-end="item.end ? moment(item.end) : null"
                :payment-data="getDailyPaymentData(item)"
                :compact="true"
              />
              <!-- Read-only fees list under the calendar (including inscription) -->
              <div class="mt-2">
                <div class="d-flex align-items-center mb-1">
                  <h6 class="mb-0">{{ $t("inscription.frais") }}</h6>
                </div>
                <div class="d-flex flex-wrap" style="gap: 8px">
                  <a-tag
                    v-for="f in item.fees"
                    :key="f._id || f.feeName"
                    :color="getFeeTagColor(f)"
                  >
                    {{ formatFeeName(f.feeName, item.daily) }}
                  </a-tag>
                </div>
              </div>
            </div>

            <!-- Table view for non-daily activities -->
            <a-table
              v-else
              :pagination="true"
              :data-source="item.fees"
              :columns="columns"
              rowKey="_id"
            >
              <template slot="isPayed" slot-scope="text">
                <a-tag v-if="text.fullyPaid" color="green">
                  <b>{{ $t("profil.payes") }}</b>
                </a-tag>
                <a-tag
                  v-else-if="!text.fullyPaid && text.remaining > 0"
                  color="orange"
                >
                  <b
                    >{{ $t("profil.paidWithAvance") }} (
                    {{ $t("recette.restePayer") }} :
                    {{ text.remaining.toFixed(2) }} )</b
                  >
                </a-tag>
                <a-tag v-else color="red">
                  <b>{{ $t("profil.nonPayes") }}</b>
                </a-tag>
              </template>
              <span slot="feeName" slot-scope="text, record">
                <p v-if="text == 'inscription'">
                  {{ $t("inscription.inscription") }}
                </p>
                <p v-else>
                  {{ formatFeeName(text, item.daily) }}
                </p>
              </span>
              <template slot="operation" slot-scope="text, record">
                <a-button
                  type="primary"
                  :disabled="status != 'active'"
                  @click="ClassRoomModal(record)"
                >
                  <a-icon type="eye" /> {{ $t("profil.paiement") }}
                </a-button>
              </template>
            </a-table>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import apiClient from "@/services/axios";
import Vue from "vue";
import VueRouter from "vue-router";
import moment from "moment";
Vue.use(VueRouter);
import { formatFeeName as formatFeeNameUtil } from "@/utilities/settings";
import activityInsForm from "./../activityInsForm";
import EditActivityModal from "@/components/comptabilite/EditActivityFeesModal.vue";
import DailyCalendar from "@/components/comptabilite/DailyCalendar.vue";

export default {
  props: {
    studentId: {
      required: true,
    },
  },
  computed: {
    ...mapState(["settings", "user"]),
    columns() {
      return [
        {
          title: this.$t("paiement.mois"),
          dataIndex: "feeName",
          key: "feeName",
          scopedSlots: {
            customRender: "feeName",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
        },
        {
          title: this.$t("profil.etat"),
          dataIndex: "isPayed",
          key: "isPayed",
          scopedSlots: {
            customRender: "isPayed",
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
          },
          scopedSlots: { customRender: "isPayed" },

          sorter: (a, b) => a.status.length - b.status.length,
          sortDirections: ["descend", "ascend"],
        },
      ];
    },
  },
  components: { activityInsForm, EditActivityModal, DailyCalendar },
  async created() {
    this.$gtag.pageview({
      page_path: this.$route.path,
      page_location: window.location.href,
      page_title: document.title + " - " + this.$t("profil.paiementAct"),
    });
  },
  mounted() {
    const building = this.user.building.find(
      (el) => el.dbName == this.settings.activeBuilding
    );
    if (building) this.reductionType = building.reductionType || "pourcentage";

    /* if (this.reductionType == "dinar")
      this.columns[1].title = "Réduction (TND)";
    else this.columns[1].title = "Réduction (%)";*/

    this.fetchPayments();
  },

  data() {
    return {
      inscriptinActDrawer: false,
      activeCollapseKey: ["0"],
      editModalVisible: false,
      selectedActivity: null,

      editingReduction: null,
      feesData: [],
      data: [],
      loading: true,
      loadingSave: false,
      moment,
      reductionType: "dinar",
      dailyViewModeById: {}, // { [paymentId]: 'calendar' | 'table' }
    };
  },
  methods: {
    onClose() {
      this.inscriptinActDrawer = false;
    },
    changeActivekey(key) {
      console.log(key);
    },
    formatFeeName(key, daily = false) {
      return formatFeeNameUtil(key, daily, this.$t.bind(this));
    },
    startInsDrawer() {
      this.inscriptinActDrawer = true;
    },
    async fetchPayments() {
      this.visibleModal = true;
      this.loading = true;
      await apiClient
        .get("/payment/manager/pvalidator/" + this.studentId)
        .then((res) => {
          this.data = res.data.filter((p) => p.typeAS == "A");
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateActivities(updates) {
      this.inscriptinActDrawer = false;
      this.fetchPayments();
    },
    cancelActInsc(item) {
      const { _id } = item;
      apiClient
        .patch("/payment/" + _id, {
          data: {
            status: "inactive",
          },
        })
        .then((r) => {
          this.$message.success(this.$t("success.inscriSupp"));
          this.fetchPayments();
        })
        .catch((r) => {
          this.$message.error(this.$t("error.impoInscriSupp"));
        });
    },
    editActInsc(item) {
      if (item.once) return;
      this.selectedActivity = {
        ...item,
        studentId: this.studentId,
        activityId: item.activityId || item.activity?._id || item.activity || "",
      };
      this.editModalVisible = true;
    },
    closeEditModal() {
      this.editModalVisible = false;
      this.selectedActivity = null;
    },
    async handleUpdatePayment() {
      try {
        this.closeEditModal();
        this.fetchPayments(); // Refresh the data
      } catch (error) {
        this.$message.error(this.$t("error.modif"));
        console.error("Error updating payment:", error);
        throw error; // Re-throw to let the modal handle loading state
      }
    },
    getDailyPaymentData(activity) {
      // Transform fees data to the format expected by DailyCalendar
      return activity.fees
        .filter((fee) => fee.feeName !== "inscription") // Exclude inscription fees
        .map((fee) => ({
          date: fee.feeName, // feeName contains the date for daily activities
          paid: fee.isPayed?.fullyPaid || false,
          remaining: fee.isPayed?.remaining || 0,
          isPayed: fee.isPayed,
        }));
    },
    getDailyUnpaidDates(activity) {
      try {
        return activity.fees
          .filter((fee) => fee.feeName !== "inscription")
          .filter((fee) => {
            const fullyPaid =
              fee?.isPayed?.fullyPaid === true || fee?.paid === true;
            const remaining = fee?.isPayed?.remaining ?? fee?.remaining ?? 0;
            return !fullyPaid && remaining <= 0; // unpaid: no payment recorded and no remaining tracked
          })
          .map((fee) => fee.feeName);
      } catch (e) {
        return [];
      }
    },
    isCalendarView(item) {
      const id = item._id || item.id || item.name;
      const mode = this.dailyViewModeById[id];
      if (!mode) return true; // default to calendar
      return mode === "calendar";
    },
    setViewMode(item, mode) {
      const id = item._id || item.id || item.name;
      this.$set(this.dailyViewModeById, id, mode);
    },
    getFeeTagColor(fee) {
      if (fee?.isPayed?.fullyPaid || fee?.paid === true) return "green";
      const remaining = fee?.isPayed?.remaining ?? fee?.remaining ?? 0;
      if (!fee?.isPayed?.fullyPaid && remaining > 0) return "orange";
      return "red";
    },
  },
};
</script>

<style scoped>
.daily-activity-view {
  margin-top: 16px;
}
</style>
